<!-- 退货审核 -->
<template>
  <div>
    <el-row>
      <el-form :model="searchForm" ref="searchForm" :inline="true" size="small">
        <el-form-item label="审核状态：" v-if="!Number(activeName)">
          <el-select size="medium" v-model="searchForm.tcAuditStatus" @change="queryTcList">
            <el-option v-for="item in tcAuditStatusList" :key="item.id" :label="item.label" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="审核状态：" v-else>
          <el-select size="medium" v-model="searchForm.supplierAuditStatus" @change="querySupplierList">
            <el-option v-for="item in supplierAuditStatusList" :key="item.id" :label="item.label" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </el-row>
    <el-row>
      <el-tabs type="border-card" v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="团餐客户">
          <el-table :data="tcTableData" stripe border>
            <el-table-column label="序号" type="index" width="50px"></el-table-column>
            <el-table-column label="送货日期" prop="SEND_DAY" min-width="100px"></el-table-column>
            <el-table-column label="项目点" prop="PROJECT_NAME"></el-table-column>
            <el-table-column label="档口" prop="DK_NAME"></el-table-column>
            <el-table-column label="退货商品" prop="PRODUCT_NAME"></el-table-column>
            <el-table-column label="退货数量" prop="RETURN_COUNT" min-width="80px"></el-table-column>
            <el-table-column label="单位" prop="TYPE_UNIT" min-width="80px"></el-table-column>
            <el-table-column label="退货理由" prop="REASON"></el-table-column>
            <el-table-column label="退货日期" prop="RETURN_DATE"></el-table-column>
            <el-table-column label="申请时间" prop="CREATE_TIME" min-width="100px"></el-table-column>
            <el-table-column label="申请人" prop="NAME" min-width="70px"></el-table-column>
            <el-table-column label="联系电话" prop="CELLPHONE" min-width="80px"></el-table-column>
            <el-table-column label="操作" fixed="right" width="220px" v-if="searchForm.tcAuditStatus">
              <template slot-scope="scope">
                <el-button size="small" type="text" @click="openTCDetail(scope.row)">退货凭证</el-button>
                <el-button size="small" type="text" v-if="IS_USING_WAREHOUSE === 0" @click="agreeReturn(scope.row)">同意
                </el-button>
                <el-button size="small" type="text" @click="openDenyDialog(scope.row)">拒绝</el-button>
              </template>
            </el-table-column>
            <el-table-column label="拒绝理由" prop="REJECT_REASON" v-else></el-table-column>
          </el-table>
          <el-pagination @current-change="handleTcCurrentChange" :current-page.sync="tcCurrentPage"
            :page-size="pageSize" layout="total,prev, pager, next, jumper" :total="tcTotalCount" style="float: right"
            v-if="!searchForm.tcAuditStatus">
          </el-pagination>
        </el-tab-pane>
        <el-tab-pane label="供应商客户">
          <el-table :data="supplierTableData" max-height="520" stripe border>
            <el-table-column label="序号" type="index" width="50px"></el-table-column>
            <el-table-column label="送货日期" prop="SEND_DAY" min-width="100px"></el-table-column>
            <el-table-column label="客户名称" prop="GYS_NAME"></el-table-column>
            <el-table-column label="申请时间" prop="APPLICATION_TIME" min-width="100px"></el-table-column>
            <el-table-column label="确认时间" prop="CONFIRM_TIME" min-width="100px"
              v-if="searchForm.supplierAuditStatus != 1">
            </el-table-column>
            <el-table-column label="操作" fixed="right" width="220px" v-if="searchForm.supplierAuditStatus">
              <template slot-scope="scope">
                <el-button size="small" type="text" @click="openSupplierDetail(scope.row)">查看详情</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination @current-change="handleSupplierCurrentChange" :current-page.sync="supplierCurrentPage"
            :page-size="pageSize" layout="total,prev, pager, next, jumper" :total="supplierTotalCount"
            style="float: right"></el-pagination>
        </el-tab-pane>
      </el-tabs>
    </el-row>
    <el-dialog title="拒绝退货" center :visible.sync="refuseFormVisible" width="600px">
      <el-form :model="refuseForm" ref="refuseForm" :close-on-click-modal="false">
        <el-form-item label="产品名称：" :label-width="formLabelWidth">
          <span>{{ refuseForm.PRODUCT_NAME }}</span>
        </el-form-item>
        <el-form-item label="拒绝原因：" :label-width="formLabelWidth">
          <el-input v-model="refuseForm.RETURN_REASON" style="width:400px;"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="refuseFormVisible = false">取 消</el-button>
        <el-button @click="submitRefuse">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  agreeReturnFun, deniedListFun, queryReturnFun, refuseReturnFun, getGYSCusReturnAuditListFun,
} from 'api/returnCheck';

export default {
  data() {
    return {
      IS_USING_WAREHOUSE: Number(sessionStorage.getItem('IS_USING_WAREHOUSE')),
      searchForm: {
        tcAuditStatus: 1,
        supplierAuditStatus: 1,
      },
      tcAuditStatusList: [{ id: 1, label: '未审批' }, { id: 0, label: '已拒绝' }],
      supplierAuditStatusList: [{ id: 1, label: '审核中' }, { id: 2, label: '已通过' }, { id: 3, label: '已拒绝' }],
      // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
      pageSize: Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10,
      tcTableData: [],
      tcCurrentPage: 1,
      tcTotalCount: 0,
      refuseFormVisible: false,
      refuseForm: {},
      formLabelWidth: '200',
      supplierTableData: [],
      supplierCurrentPage: 1,
      supplierTotalCount: 0,
      activeName: sessionStorage.getItem('returnAuditTabActiveName') || '0',
    };
  },
  components: {
  },
  created() {
    if (!Number(this.activeName)) {
      this.queryTcList();
    } else {
      this.querySupplierList();
    }
  },
  methods: {
    handleClick(tab, event) {
      sessionStorage.setItem('returnAuditTabActiveName', this.activeName);
      if (Number(this.activeName)) this.querySupplierList(); else this.queryTcList();
    },
    queryTcList() {
      if (this.searchForm.tcAuditStatus) {
        queryReturnFun().then((result) => {
          if (result.length !== 0) {
            this.tcTableData = result;
          } else {
            this.tcTableData = [];
            this.$message.show({ text: '暂无数据', type: 'success' });
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
      } else {
        const params = {
          PAGESIZE: this.pageSize,
          PAGEINDEX: this.tcCurrentPage - 1,
        };
        deniedListFun(params).then((result) => {
          if (result.length !== 0) {
            this.tcTableData = result[0].list;
            this.tcTotalCount = result[0].TOTAL_COUNT;
          } else {
            this.tcTableData = [];
            this.tcTotalCount = 0;
            this.$message.show({ text: '暂无数据', type: 'success' });
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
      }
    },
    openTCDetail(row) {
      this.$router.push({ path: '/checkDetail/detail' });
      sessionStorage.setItem('orderId', row.DETAIL_ID);
    },
    // 同意团餐退货
    agreeReturn(row) {
      const params = {
        SERVICE_ID: '10028',
        OTYPE: 19,
        RETURN_ID: row.RETURN_ID,
      };
      agreeReturnFun(params).then((result) => {
        this.$message.show({ text: '审核通过', type: 'success' });
        this.queryTcList();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 拒绝团餐退货
    openDenyDialog(row) {
      this.refuseFormVisible = true;
      this.refuseForm = { ...row };
    },
    submitRefuse() {
      const params = {
        RETURN_ID: Number(this.refuseForm.RETURN_ID),
      };
      if (this.refuseForm.RETURN_REASON) {
        params.REJECT_REASON = this.refuseForm.RETURN_REASON;
      } else {
        this.$message.show({ text: '请输入拒绝退货申请理由', type: 'warning' });
      }
      refuseReturnFun(params)
        .then((result) => {
          this.$message.show({ text: '操作成功', type: 'success' });
          this.queryTcList();
          this.refuseFormVisible = false;
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
      // this.$confirm('确定拒绝吗?', '提示', {
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消',
      //   type: 'warning',
      // }).then(() => {
      //   const params = {
      //     RETURN_ID: Number(row.RETURN_ID),
      //   };
      //   refuseReturnFun(params)
      //     .then((result) => {
      //       this.$message.show({ text: '操作成功', type: 'success' });
      //       this.queryTcList();
      //     }).catch((error) => {
      //       this.$message.show({ text: error, type: 'error' });
      //     });
      // }).catch(() => {
      //   this.$message.show({ type: 'info', text: '已取消操作' });
      // });
    },
    handleTcCurrentChange(e) {
      this.tcCurrentPage = e;
      this.queryTcList();
    },
    querySupplierList() {
      getGYSCusReturnAuditListFun({ STATUS: this.searchForm.supplierAuditStatus }).then((res) => {
        this.supplierTableData = res.LIST;
        this.supplierTotalCount = res.TOTAL_COUNT;
        if (!this.supplierTotalCount) this.$message.show({ text: '暂无数据', type: 'success' });
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    handleSupplierCurrentChange(e) {
      this.supplierCurrentPage = e;
      this.querySupplierList();
    },
    openSupplierDetail(row) {
      this.$router.push({ path: `/returnAuditSupplierCusDetail/${row.GYS_ID}/${row.APPROVAL_ID}`, params: { gid: row.GYS_ID, aid: row.APPROVAL_ID } });
      sessionStorage.setItem('returnAuditSupplierCusDetailTitleData', JSON.stringify({
        GYS_NAME: row.GYS_NAME,
        SEND_DAY: row.SEND_DAY,
        APPLICATION_TIME: row.APPLICATION_TIME,
        STATUS: row.STATUS,
      }));
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/audit/returnAudit.vue